import { Checkbox, FormControlLabel } from '@material-ui/core';
import { Filter } from './Filter';

export type StarredFilterProps = {
  starredOnly: boolean;
  onToggle: () => void;
};

export const StarredFilter = (props: StarredFilterProps) => {
  const { starredOnly, onToggle } = props;
  return (
    <Filter label="Starred">
      <FormControlLabel
        control={<Checkbox checked={starredOnly} onChange={onToggle} size="small" />}
        label="Show starred only"
      />
    </Filter>
  );
};
